<div class="choice-card-stage" [class.has-overlay]="isOverlay">
  <button
    *ngIf="showEntry"
    type="button"
    class="entry-card"
    [class.is-faded]="isOverlay"
    [disabled]="isOverlay"
    [ngStyle]="entryStyles"
    (click)="onEntryClick()"
    (keydown)="onEntryKeydown($event)">
    <span class="entry-icon material-symbols-outlined" aria-hidden="true">{{ entryCard?.icon || 'request_quote' }}</span>
    <span class="entry-copy">
      <span class="entry-title">{{ entryCard?.title }}</span>
      <span class="entry-description" *ngIf="entryCard?.description">{{ entryCard?.description }}</span>
    </span>
  </button>

  <section class="choice-card" *ngIf="showActions" [class.is-overlay]="isOverlay" [ngStyle]="cardStyles">
    <header class="choice-card-header" *ngIf="title || subtitle">
      <h2 class="choice-card-title" *ngIf="title">{{ title }}</h2>
      <p class="choice-card-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    </header>

    <div class="choice-actions" [class.is-column]="isColumnLayout">
      <button
        *ngFor="let action of actions"
        type="button"
        class="choice-action"
        [ngClass]="actionClasses(action)"
        [disabled]="action.disabled"
        [attr.aria-label]="action.label"
        (click)="onActionClick(action)">
        {{ actionLabel(action) }}
      </button>
    </div>
  </section>
</div>
